<ion-header>
    <ion-toolbar>

    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item-divider class="list-header" color="light">
            <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ eventType }}.png'>
            <div class="primary">{{ eventArea }}</div>
        </ion-item-divider>
        <button ion-item class="list-item" *ngFor="let event of arrayOf(); index as i" (click)="onEventLoad(event)">
            <h4>{{ event.dateFormatted }}</h4>
            <h4 class="padding-left" text-nowrap>{{ event.eventName }}</h4>
        </button>
    </ion-list>

    <ion-infinite-scroll #infiniteScroll (ionInfinite)="loadNextPage(infiniteScroll)">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
            loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll>
</ion-content>